/**
 * Orders a table by the given column name specified in orderBy
 * @param {List} rows
 * @param {String} orderBy
 */
export function orderRows(rows, orderBy, descending) {
    switch (orderBy) {
        case 'totalDowntime':
            return rows.sort(
                (a, b) =>
                    b['availability'][orderBy] - a['availability'][orderBy]
            );
        default:
            if (descending) {
                return rows.sort((a, b) => b[orderBy] - a[orderBy]);
            } else {
                return rows.sort((a, b) => a[orderBy] - b[orderBy]);
            }
    }
}
